// GTM event tracking — constants
// Port of Docs/07-gtm-events-copy/gtm-events-constants.ts, scoped to the SEO contract
// in Docs/07-gtm-events-copy/01-GTM-Events-Requirements.md.

export const EVENT_NAMES = {
  PAGE_DESCRIPTION: 'page_description',
  VIRTUAL_PAGE_VIEW: 'virtual_page_view',
  BUTTON_CLICK: 'button_click',
  BLOG_BUTTON_CLICK: 'blog_button_click',
  VIEW_SEARCH_RESULTS: 'view_search_results',
  BLOG_VIEWED: 'blog_viewed',
  LEAD_VIEW: 'lead_view',
  LEAD_SUCCESS: 'lead_success',
  LEAD_REDIRECT: 'lead_redirect',
  LEAD_SUBSCRIPTION: 'lead_subscription',
  FORM_VIEW: 'form_view',
  FORM_SELECT: 'form_select',
  FORM_RESULT: 'form_result',
}

export const BUTTON_LOCATIONS = {
  HEADER_TOP: 'header_top',
  HEADER: 'header',
  NAVIGATION_MENU: 'navigation_menu',
  FOOTER_MENU: 'footer_menu',
  BLOG_CATEGORIES: 'blog_categories',
  BLOG_SEARCH: 'blog_search',
  SITE_SEARCH: 'site_search',
  UYUMLU_URUNLER_VE_DIKEY_COZUMLER: 'uyumlu_urunler_ve_dikey_cozumler',
}

export const CONTENT_GROUPS = {
  PAGE: 'Sayfa',
  HOME_PAGE: 'Ana Sayfa',
  DETAIL_PAGE: 'Detay Sayfası',
  NO_CATEGORY: 'Kategori Yok',
  BLOG_PAGES: 'Blog Sayfaları',
  BLOG: 'Blog',
}

export const PAGE_TYPES = {
  HOME_PAGE: 'home_page',
  PAGE_SUFFIX: '_page',
}

export const LEAD_TYPES = {
  SUBSCRIPTION: 'Subscription',
}
